import {makeAutoObservable} from "mobx";

class Nps {
    [Symbol.toStringTag] = this.constructor.name;
    public phone: any | null = null;

    constructor() {
        makeAutoObservable(this);
    }
}

export default Nps;
